module.exports = function() {
  this.data.forEach(function(row, index) {
    this.opts.dateColumns.forEach(function(column) {
      row[column] = moment(row[column], this.opts.toMomentFormat);
    }.bind(this));
  }.bind(this));
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/transform-date-strings-to-moment.js